// removed by extract-text-webpack-plugin
module.exports = {"MyNewMazda":"MyNewMazda__MyNewMazda___2dROG","MyNewMazdaForm":"MyNewMazda__MyNewMazdaForm___13Qh0","MyNewMazdaFormWrapper":"MyNewMazda__MyNewMazdaFormWrapper___3z2-6","MyNewMazdaFormInput":"MyNewMazda__MyNewMazdaFormInput___1fqjq","MyNewMazdaFormButton":"MyNewMazda__MyNewMazdaFormButton___2rgMM","MyNewMazdaLoadingSection":"MyNewMazda__MyNewMazdaLoadingSection___K3mDW"};


//////////////////
// WEBPACK FOOTER
// ./src/AtomicContainers/MyNewMazda/MyNewMazda.less
// module id = 1190
// module chunks = 0 1